// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ce30f973","197":"c047fa69","256":"330ecc5c","321":"4ac2f0ab","724":"229faaeb","745":"2f6aae36","924":"f0bc64ea"}[chunkId] + ".chunk.js";
};